module.exports = __webpack_public_path__ + "img/mono_39.cb5c0084.png";